import { Divider, Row } from '@faceup/ui-base'
import { useContext, useEffect } from 'react'
import { type FragmentType, getFragmentData, graphql } from '../../../../__generated__'
import { LayoutContext } from '../../../../Contexts/LayoutContext'
import LanguageDropdown from '../../../LanguageDropdown'
import { LogoutButton } from '../../../LogoutButton'
import { NavbarContent } from './NavbarContent'

const fragments = {
  InstitutionLayoutNavbar_reportSource: graphql(`
    fragment InstitutionLayoutNavbar_reportSource on PublicReportSource {
      id
      languages
      defaultLanguage

      ...InstitutionLayoutNavbarContent_reportSource
    }
  `),
}

type NavbarProps = {
  reportSource: FragmentType<typeof fragments.InstitutionLayoutNavbar_reportSource>
  isOpened: boolean
}

export const Navbar = ({ reportSource: _reportSource, isOpened }: NavbarProps) => {
  const reportSource = getFragmentData(
    fragments.InstitutionLayoutNavbar_reportSource,
    _reportSource
  )
  const { client } = useContext(LayoutContext)

  useEffect(() => {
    if (isOpened) {
      document.body.style.overflow = 'hidden'
    } else {
      // default value is empty string
      document.body.style.overflow = ''
    }
    // On umnount set overflow to default value
    return () => {
      document.body.style.overflow = ''
    }
  }, [isOpened])

  const isApp = client === 'app'
  return (
    <div
      className={`${isOpened ? 'fixed' : 'hidden'} top-[108px] left-0 right-0 flex flex-col justify-between ${isApp ? `bottom-[calc(70px+var(--safe-area-inset-bottom))]` : `bottom-[200px]`} bg-white z-50`}
    >
      <div className={`overflow-auto relative p-3`}>
        <NavbarContent reportSource={reportSource} />
      </div>
      {isApp && (
        <div>
          <Divider />
          <Row className='px-4 py-2 justify-between'>
            <LanguageDropdown
              availableLanguages={reportSource.languages}
              defaultLanguage={reportSource.defaultLanguage}
            />
            <LogoutButton size='small' />
          </Row>
        </div>
      )}
    </div>
  )
}
